import { css } from 'lit';
export default css ``;
//# sourceMappingURL=styles.js.map